import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard");
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#050805]" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <button onClick={() => navigate("/")} className="font-grotesk font-extrabold text-3xl tracking-[0.3em] mb-2">LUXOR</button>
        <p className="font-body text-xs uppercase tracking-[0.3em] text-[#29FF87] mb-12">Admin Access</p>

        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="font-body text-[10px] uppercase tracking-[0.3em] text-zinc-500">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-transparent border-b border-white/20 focus:border-[#29FF87] outline-none py-3 font-body text-sm transition-colors" data-testid="login-email" />
          </div>
          <div>
            <label className="font-body text-[10px] uppercase tracking-[0.3em] text-zinc-500">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-transparent border-b border-white/20 focus:border-[#29FF87] outline-none py-3 font-body text-sm transition-colors" data-testid="login-password" />
          </div>
          <button type="submit" disabled={submitting}
            className="w-full bg-[#29FF87] text-[#050805] py-4 font-body text-sm uppercase tracking-[0.25em] font-semibold hover:bg-[#5CFFA8] disabled:opacity-50 transition-colors" data-testid="login-submit">
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
